import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../common/Modal';

const ConfirmationModal = ({ close, confirm, submitting }) => (
  <Modal title="Merge records" close={close} showCloseButton>
    <div className="c-modal__text u-max-width-530 u-pv u-margin-auto u-fontsize-medium">
      Are you sure you want to merge these records?
    </div>
    <div className="u-text-right u-m">
      <button
        type="button"
        className="c-btn c-btn--grey u-width-120 u-mr"
        onClick={close}
        disabled={submitting}
      >
        No
      </button>
      <button
        type="button"
        className="c-btn u-width-120"
        onClick={confirm}
        disabled={submitting}
      >
        Yes
      </button>
    </div>
  </Modal>
);

ConfirmationModal.propTypes = {
  close: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default ConfirmationModal;
